module.exports = __webpack_public_path__ + "static/media/GTBSLong2w522@1x.339dc8f2.jpg";